import type { GridMouseHeaderEventArgs } from '@glideapps/glide-data-grid';

import { Lang } from '../../types';

import { Menu, Item } from '@/components/Menu';
import { useCallback } from 'react';

interface Props {
  cell: GridMouseHeaderEventArgs;
  lang: Lang;
  onClick: (lang: Lang) => void;
  onClose: () => void;
}

const isLang = (lang: string): lang is Lang =>
  lang === 'en-GB' || lang === 'en-US' || lang === 'en-CA';

export const DateFormatSelect = ({ cell, lang, onClick, onClose }: Props) => {
  const handleAction = useCallback(
    (key: number | string | null) => {
      const value = String(key);
      if (!isLang(value)) return;
      onClick(value);
    },
    [onClick]
  );

  const { x: left, y: top, width, height } = cell.bounds;

  return (
    <div
      className="absolute"
      style={{
        top: top + height - 6,
        left,
        width,
      }}
    >
      <Menu
        label={<span aria-label="Pick date format"></span>}
        defaultOpen={true}
        placement="bottom start"
        selectedKeys={[lang]}
        selectionMode="single"
        onAction={handleAction}
        onOpenChange={(isOpen) => !isOpen && onClose()}
      >
        <Item textValue="DD/MM/YYYY" key="en-GB">
          <p className="m-0 text-xs text-legacy-darkergray">DD/MM/YYYY</p>
        </Item>
        <Item textValue="MM/DD/YYYY" key="en-US">
          <p className="m-0 text-xs text-legacy-darkergray">MM/DD/YYYY</p>
        </Item>
        <Item textValue="YYYY/MM/DD" key="en-CA">
          <p className="m-0 text-xs text-legacy-darkergray">YYYY/MM/DD</p>
        </Item>
      </Menu>
    </div>
  );
};
